module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d687b0a389aebcfb6110b83445a26e53.png";